import { ReactNode } from 'react';
import { useTableInheritedProps } from '@rhino-project/core/hooks';

export interface FooterProps {
  children?: ReactNode;
  [key: string]: unknown;
}

export const Footer = ({ children, ...props }: FooterProps) => {
  const { inheritedProps } = useTableInheritedProps(props);

  return <div {...inheritedProps}>{children}</div>;
};
